<template>
  <v-list :class="$style['navi-icon']">
    <template v-for="item in items">
      <div :key="item.attributes.title" :class="userAgentClass(item)">
        <v-list-item v-if="item.children.length === 0" :href="item.href" :to="item.to" link>
          <v-list-item-content @click="$emit('item-click')">
            <v-list-item-title><NavigationElement v-bind="item" /></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-expansion-panels v-else :key="item.attributes.title">
          <template v-if="renderHeaderAsNavigationElement(item)">
            <MobileMenuItemListAccordion
              :items="item.children"
              :header="item.attributes.title"
              :render-header-text="false"
              :class="$style.accordionNavigationElement"
              @item-click="$emit('item-click')"
            >
              <template #accordionHeader>
                <NavigationElement v-bind="item" :disabled="true" />
              </template>
            </MobileMenuItemListAccordion>
          </template>
          <template v-else>
            <MobileMenuItemListAccordion
              :items="item.children"
              :header="item.attributes.title"
              @item-click="$emit('item-click')"
            />
          </template>
        </v-expansion-panels>
      </div>
    </template>
    <div :class="$style['account-buttons']">
      <NavigationLogoutItem class="py-5 my-5" />
      <NavigationStoreModeItem :class="$style['store-item']" class="py-5" />
    </div>
  </v-list>
</template>

<script>
import { uniq } from 'lodash-es'

import NavigationElement from '@/js/components/Navigation/NavigationElement.vue'
import MobileMenuItemListAccordion from '@/js/components/Navigation/mobile/MobileMenuItemListAccordion.vue'

import CONSTANTS from '../utils/navigation-constants'

import NavigationLogoutItem from '@/js/components/Navigation/NavigationLogoutItem.vue'
import NavigationStoreModeItem from '@/js/components/Navigation/NavigationStoreModeItem.vue'

export default {
  components: {
    NavigationElement,
    MobileMenuItemListAccordion,
    NavigationLogoutItem,
    NavigationStoreModeItem,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  // watch: {
  //   items: {
  //     handler(nextVal) {
  //       nextVal?.forEach(item => {
  //         if (item[CONSTANTS.LINK_TILE_CHILDREN] && item[CONSTANTS.LINK_TILE_CHILDREN].length) {
  //           item.children = uniq(
  //             item[CONSTANTS.CHILDREN].concat(item[CONSTANTS.LINK_TILE_CHILDREN]),
  //           )
  //         }
  //       })

  //       nextVal = uniq(nextVal)
  //     },
  //     immediate: true,
  //   },
  // },
  methods: {
    userAgentClass(item) {
      let className = ''
      switch (item.attributes.user_agent_type) {
        case CONSTANTS.USER_AGENTS.MOBILE:
          className = 'mobile-only'
          break
        case CONSTANTS.USER_AGENTS.DESKTOP:
          className = 'desktop-only'
          break
        default:
          className = null
          break
      }
      return className
    },
    renderHeaderAsNavigationElement(item) {
      const whitelist = ['NavigationMessageCenter']

      return whitelist.includes(item?.attributes?.component)
    },
  },
}
</script>

<style lang="scss" module>
.navi-icon {
  margin-bottom: 3.5rem;

  :global(.v-list-item) {
    &:hover {
      &:before {
        opacity: 1;
      }
    }

    &:before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;

      background-color: transparent;
      border-bottom: 1px solid #eee;

      opacity: 1;

      transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);

      content: '';
      will-change: box-shadow;
    }

    :global(.v-list-item__content) {
      @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
        flex: 1 1;
        width: auto;
        padding: 12px 0;
      }
      flex: unset !important;
      width: 100%;
      padding: 0 !important;

      :global(.v-list-item__title) {
        font-size: 0.9375rem;
      }
    }
  }

  :global(.v-expansion-panel) {
    &:before {
      z-index: 0;

      border-bottom: 1px solid #eee;
      box-shadow: unset !important;
    }

    :global(.v-expansion-panel-header) {
      padding: 16px 15px;
    }
  }
}

.account-buttons {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  min-height: 1.75rem !important;
  margin: 0 10px;
}

.store-item {
  :global(.v-input--selection-controls) {
    margin-top: 0;
  }
}

.accordionNavigationElement {
  :global(.v-expansion-panel-header) {
    padding: 0 15px !important;
  }
}
</style>
